import { createTheme } from '@mui/material/styles';
import constants from '@shared-styles/constants.module.scss';

/**
 * MUI theme to correct styling on Material components.
 */
const theme = createTheme({
  typography: {
    fontFamily: 'Roboto Light, Roboto, Arial, sans-serif',
    fontWeightRegular: 300
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26)',
            backgroundColor: 'transparent'
          }
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: constants.levelThree
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '28px',
          textTransform: 'none'
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          padding: '1rem',
          borderRadius: '1rem',
          color: constants.inputColor,
          backgroundColor: constants.inputBackground
        },
        multiline: {
          color: constants.inputColor,
          fontFamily: constants.defaultFont,
          lineHeight: 1.18,
          minWidth: '35rem',
          margin: 0,
          alignItems: 'flex-start',
          borderRadius: '1rem',

          [`@media (max-width:${constants.small}px)`]: {
            minWidth: '25rem'
          },

          '&:focus-within': {
            outline: `1px solid ${constants.isacaTeal}`
          },

          '&.Mui-error': {
            border: `1px solid ${constants.validationErrorColor}`
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: constants.inputColor,
          height: 'auto',
          whiteSpace: 'normal',
          minHeight: '56px',
          borderRadius: '15px',
          ['@media (min-width:600px)']: {
            minHeight: '56px'
          },
          '&.Mui-selected': {
            backgroundColor: 'transparent',
            fontWeight: 700
          },
          '&:hover': {
            backgroundColor: constants.inputBackgroundFocus
          },
          '&:focus': {
            backgroundColor: 'transparent',
            border: `2px solid ${constants.dropDownBorder}`
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%'
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          whiteSpace: 'normal',
          height: 'auto',
          minHeight: '56px'
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: constants.inputColor
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: constants.levelFour
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          zIndex: constants.levelFour
        }
      }
    }
  }
});

export default theme;
